'use client';

import Image from 'next/image';
import { Suspense } from 'react';
import { SearchFilters } from '@/components/properties/SearchFilters';
import { useTranslation } from '@/contexts/LanguageContext';

export function Hero() {
    const { t } = useTranslation();

    return (
        <section className="relative h-[90vh] min-h-[450px] flex items-center justify-center text-white overflow-hidden">
            <Image
                src="/images/hero-img.jpg"
                alt="Luxury home with a pool at dusk"
                width={1920}
                height={1080}
                className="absolute z-0 w-full h-full object-cover"
                data-ai-hint="modern house exterior"
                priority
            />
            <div className="absolute inset-0 bg-black/75" />
            <div className="relative z-10 text-center p-4 max-w-4xl mx-auto">
                <h1 className="text-4xl md:text-6xl font-bold mb-4 drop-shadow-lg">
                    {t.home.heroTitle}
                </h1>
                <p className="text-lg md:text-xl mb-8 drop-shadow-md">
                    {t.home.heroSubtitle}
                </p>
                <div className="bg-card/10 backdrop-blur-sm p-6 rounded-lg animate-fade-in sticky top-8">
                    <Suspense fallback={<div className="h-12" />}>
                        <SearchFilters />
                    </Suspense>
                </div>
            </div>
            {/* Animated scroll indicator */}
            <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-20 flex flex-col items-center">
                <span className="animate-bounce text-white text-3xl">↓</span>
            </div>
        </section>
    );
}
